/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusWithSections"/>

import * as React from 'react';
import { EmailStatusList } from './components/emailStatusList';

interface EmailStatusWithSectionsProps {
    documentId: string;
    importTrackingId?: string | null;
}

export const EmailStatusWithSections = (props: EmailStatusWithSectionsProps) => {
    return (
        <div>
            <EmailStatusList documentId={props.documentId} importTrackingId={props.importTrackingId || undefined} />
        </div>
    );
};
